import { Subscription } from 'rxjs';
import { UploadFileService } from 'src/app/shared/providers/upload-file.service';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {
  IGroupedCard,
  IUploadCardEvent,
  UPLOAD_STATUS
} from 'src/app/models/groupedCard';
import {
  environment
} from 'src/environments/environment';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { SettingsService } from '../../providers/settings.service';
import { DialogService } from '../../providers/dialog.service';
import { UtilityFunctionsService } from '../../providers/utility-functions.service';

@Component({
  selector: 'app-card-thumbs-upload',
  templateUrl: './card-thumbs-upload.component.html',
  styleUrls: ['./card-thumbs-upload.component.scss']
})
export class CardThumbsUploadComponent implements OnInit, OnDestroy {
  @Output() thumbCardClicked = new EventEmitter < IGroupedCard > ();
  @Output() stopUploadButtonClicked = new EventEmitter < IGroupedCard > ();
  @Output() retryUploadButtonClicked = new EventEmitter < IGroupedCard > ();
  @Output() uploadProgresschange = new EventEmitter < boolean > ();


  // eslint-disable-next-line max-len
  @Input() isStopBtnAllowed: boolean = true;
  @Input() isTotalProgressBar: boolean = false;
  @Input() uploadCard: IGroupedCard;
  @Input() smallProgressBar: boolean;

  public UPLOAD_STATUS = UPLOAD_STATUS;
  public totalProgress: number = 0;
  public debugMode: boolean = environment.showServicePageAndShowDebugData;
  uploadSub: Subscription;


  constructor(public uploadService: UploadFileService,
    public settingService: SettingsService,
    public dialogService: DialogService,
    public utilityService: UtilityFunctionsService,
  ) {}

  ngOnInit(): void {
    if(this.isTotalProgressBar) {
      this.uploadSub = this.uploadService.itemsTotalProgressSubject.subscribe((progressValue) => {
        console.log('val recieved: ', progressValue);
        this.totalProgress = progressValue;
        this.uploadProgresschange.emit(true);
      })
    }
  }

  public onThumbCardClick(thumb: IGroupedCard, event: Event): void {
    event.stopPropagation();
    if(thumb.uploadStatus.status === UPLOAD_STATUS.ERROR && this.isStopBtnAllowed) {
      console.log('ERROR upload click, card id: ', thumb.id)
      this.handleErrorUploadThumbClick(thumb);
      return;
    }
    this.thumbCardClicked.emit(thumb)
  }

  public retryClick(card: IGroupedCard, event: Event): void {
    event.stopPropagation();
    // this.retryUploadButtonClicked.emit(card);
    this.uploadService.retryCardUpload(card);
  }

  public handleErrorUploadThumbClick(card: IGroupedCard): void {
    console.log('ERROR upload click, card: ', card)

    // Check if the error is related to missing MTL file or missing textures
    const hasMissingTexturesError = card.details && (
      card.details.includes('Not all textures, required by model, uploaded to app') ||
      card.details.includes('mtl-file')
    );

    const hasMissingTextures = card.missingTextures && card.missingTextures.length > 0;
    const noAllMappedTextures = card.missingTextures && card.mappedTextures && card.mappedTextures.length < card.missingTextures.length;

    if (hasMissingTexturesError || hasMissingTextures || noAllMappedTextures) {
      console.log('Render model error (web): Missing textures or MTL file detected. ', card);
      this.utilityService.rollbarInfo('Missing textures or MTL file detected', true);

      this.dialogService.openMissingTextureMappingDialog(card).subscribe(result => {
        if (result === true) {
          if (environment.type === 'web') {
            console.log('User completed texture mapping');
          }
          // Optionally handle the result of texture mapping
        }
      });
    } else {
      // Handle other errors with the standard error dialog
      this.dialogService.openUploadErrorDialog(card).subscribe(result => {
        if (result === true) {
          console.log('User selected "Yes"');
          this.uploadService.abortUploadToFirebase(card);
        }
      });
    }
  }

  public stopUploadBtnClick(event: Event, card: IGroupedCard): void {
    console.log('STOP upload click, card id: ', card.id)

    if (this.isStopBtnAllowed === false) { this.thumbCardClicked.emit(); return }
    if (card.uploadStatus.status === UPLOAD_STATUS.PROCESSING) {
      this.uploadService.stopCardRender(card);
      return
    }
    if (card.uploadStatus.status !== UPLOAD_STATUS.INPROGRESS) return
    console.log('STOP upload click, card id EMIT: ', card.id)
    event.stopPropagation();
    // this.stopUploadButtonClicked.emit(card);
    this.uploadService.stopCardUpload(card);
  }

  public getCardUploadText(): string {
    const cardsInProgress = this.uploadService.uploadModels.filter((groupedCard) => {return groupedCard.uploadStatus.status === UPLOAD_STATUS.INPROGRESS || groupedCard.uploadStatus.status === UPLOAD_STATUS.PROCESSING});

    if(this.isTotalProgressBar && cardsInProgress.length > 1) {
      return `${cardsInProgress.length} models`
    }
    return this.uploadCard.uploadStatus.progressMsg
  }

  public getUploadProgressValue(): number {
    if(this.isTotalProgressBar) return this.totalProgress;
    return this.uploadCard.uploadStatus.progress;
  }

  public getSpinnerMode(): ProgressSpinnerMode {
    if(this.isTotalProgressBar) {
      return 'determinate';
    }

    // Show indeterminate spinner for uploading, determinate for processing
    if(this.uploadCard.uploadStatus.status === UPLOAD_STATUS.INPROGRESS) {
      return 'indeterminate';
    } else if(this.uploadCard.uploadStatus.status === UPLOAD_STATUS.PROCESSING) {
      return 'determinate';
    }

    return this.uploadCard.uploadStatus.spinnerMode;
  }

  processcardPosterMobile(cardPosterMobile: string): string {
    if (cardPosterMobile === undefined || cardPosterMobile === null || cardPosterMobile === '') {
      return '/assets/images/gradientMock.png';
    }
    return cardPosterMobile.startsWith('http') ? cardPosterMobile : encodeURI(cardPosterMobile);
  }

  ngOnDestroy(): void {
    if(this.uploadSub) this.uploadSub.unsubscribe();
  }

}
